import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchLandingPageAction, FetchProcurementSearchIndexAction } from "../../redux/action/LandingPageAction";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { LoadingSpinner } from "pepsico-ds";
import { Outlet, useNavigate } from "react-router-dom";
import LandingPageHeader from "../../components/Header/LandingPageHeader";
import MainHeader from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Layout, Row, Col } from "antd";

const { Content } = Layout;

function AcademyLanding() {
	const dispatch = useDispatch();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
	
	useEffect(() => {
        if (authState?.isAuthenticated) {
            dispatch(FetchProcurementSearchIndexAction());
        }
    }, [authState?.isAuthenticated, dispatch]);

    useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				// dispatch(FetchLandingPageAction(user));
			}
		}
		fetchUserInfo();
	}, []);

	const userData = useSelector((state) => state.getLandingPageReducer);
	
    /* istanbul ignore next */
    useEffect(() => {
		
    }, [userData])

	if(authState?.isAuthenticated){
		return(
			
                <>
                    <Layout>
                        {/* <MainHeader /> */}
                        {/* , height: "100%" */}
                        <div style={{ display: "flex", background: "#D7E5F8" }}> 
                            {/* <Sidebar /> */}
                            {/* <div style={{ width: '100%' }}> */}
                            <Content style={{ padding: '0 30px 30px 100px', background: '#D7E5F8', minHeight:"125vh" }}>
                                {userInfo && Object.keys(userInfo).length === 0 ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 'calc(100vh - 64px)' }}>
                                        <LoadingSpinner
                                            size={{
                                                height: '80px',
                                                width: '80px'
                                            }}
                                        />
                                    </div>
                                    : 
                                        <Outlet/>
                                    }
                            </Content>
                            {/* </div> */}
					    </div>
				    </Layout>
				</>
                    
		)
	}
}

export default AcademyLanding;